
export const it = {
  auth: {
    login: "Accedi",
    startFreeTrial: "Inizia la prova gratuita",
    register: "Registrati",
    email: "Email",
    password: "Password",
    forgotPassword: "Password dimenticata?",
    alreadyHaveAccount: "Hai già un account?",
    dontHaveAccount: "Non hai un account?",
    errorDescription: "Si è verificato un errore",
    errorTitle: "Errore",
    successTitle: "Successo",
    successDescription: "Operazione completata con successo",
    continueWithGoogle: "Continua con Google",
    createAccount: "Crea account",
    trialDescription: "14 giorni di prova gratuita",
    emailPlaceholder: "tua@email.com",
    creating: "Creazione in corso...",
    create: "Crea",
    errorMessage: "Si è verificato un errore"
  },
  navigation: {
    pricing: "Prezzi",
    about: "Chi siamo",
    contact: "Contatti",
    themes: "Temi",
    resources: "Risorse",
    home: "Home",
    dashboard: "Dashboard",
    products: "Prodotti",
    orders: "Ordini",
    customers: "Clienti",
    settings: "Impostazioni"
  },
  footer: {
    acceptedPayments: "Pagamenti accettati",
    allRightsReserved: "Tutti i diritti riservati",
    quickLinks: "Link rapidi",
    legalNotice: "Note legali",
    accessibility: "Accessibilità",
    termsOfUse: "Termini di utilizzo",
    support: "Supporto",
    followUs: "Seguici",
    socialMedia: "Trovaci sui social media",
    newsletter: "Newsletter",
    subscribeNewsletter: "Iscriviti alla nostra newsletter",
    emailPlaceholder: "La tua email",
    subscribe: "Iscriviti",
    changeLanguage: "Cambia lingua"
  },
  pricing: {
    title: "Piani e prezzi",
    subtitle: "Scegli il piano più adatto a te",
    startTrial: "Inizia la prova gratuita",
    mostPopular: "Più popolare",
    freeTrial: "14 giorni di prova gratuita",
    perMonth: "/mese",
    basic: {
      name: "Base",
      price: "11",
      description: "Per iniziare",
      features: [
        "1 negozio",
        "100 prodotti",
        "Supporto email"
      ]
    },
    pro: {
      name: "Pro",
      price: "25",
      description: "Per professionisti",
      features: [
        "3 negozi",
        "1000 prodotti",
        "Supporto prioritario",
        "Analisi avanzate"
      ]
    },
    enterprise: {
      name: "Enterprise",
      price: "97",
      description: "Per grandi aziende",
      features: [
        "Negozi illimitati",
        "Prodotti illimitati",
        "Supporto dedicato",
        "API personalizzata"
      ]
    }
  },
  profile: {
    title: "Il mio profilo",
    fullName: "Nome completo",
    phoneNumber: "Numero di telefono",
    update: "Aggiorna",
    updating: "Aggiornamento in corso...",
    success: "Profilo aggiornato con successo",
    error: "Errore durante l'aggiornamento del profilo"
  },
  common: {
    loading: "Caricamento...",
    error: "Errore",
    success: "Successo",
    save: "Salva",
    cancel: "Annulla",
    delete: "Elimina",
    edit: "Modifica",
    create: "Crea",
    search: "Cerca",
    filter: "Filtra",
    sort: "Ordina",
    actions: "Azioni",
    confirm: "Conferma",
    back: "Indietro",
    next: "Avanti",
    previous: "Precedente",
    close: "Chiudi"
  }
};
